import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-empty-state',
  template: `
    <div class="flex flex-col items-center justify-center py-16 text-center">
      <div class="flex h-16 w-16 items-center justify-center rounded-2xl bg-slate-100">
        <lucide-icon [name]="icon" [size]="28" class="text-slate-400" [strokeWidth]="1.5"></lucide-icon>
      </div>
      <h3 class="mt-4 text-sm font-semibold text-slate-900">{{ title }}</h3>
      <p class="mt-1.5 max-w-xs text-sm text-slate-500">{{ description }}</p>
    </div>
  `,
})
export class EmptyStateComponent {
  @Input() icon = 'inbox';
  @Input() title = 'Nothing here yet';
  @Input() description = 'Content will appear here once available.';
}
